// extracted by mini-css-extract-plugin
export default {"popup_wrap":"style_popup_wrap__r3mtu","sub_title":"style_sub_title__551iD","stu_wrap":"style_stu_wrap__9G1z8","stu_item":"style_stu_item__-8xcE"};